<template>
    <div class="row">
        <div class="col-md-4 mt-4">
            <div class="card border-0">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Immunizations</p>
                    </div>
                </div>
                <div class="row justify-content-center ">
                    <div class="col-md-12">
                        <ul class="list-group mb-3" v-if="ims.length>0">
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 border-bottom-0 ml-0 mr-0" v-for="i in ims">
                                <div class="row border-bottom">
                                    <div class="col-md-7 sb-list-fitem-regular">
                                        {{ i.imm_sr ? i.imm_srname : i.immunization_data.imd_name }}
                                    </div>
                                    <div class="col-md-3 text-right sb-list-sitem">
                                        <a href="#" class="text-danger" @click="deleteImById(i)">
                                            Remove
                                        </a>
                                    </div>
                                    <div class="col-md-2 text-right sb-list-sitem">
                                        <a href="#" class="color-sky-blue-3" @click.prevent="show(i)">
                                            Edit
                                        </a>
                                    </div>
                                </div>
                                <ul class="list-group">
                                    <li class="list-group-item border-top-0 border-left-0 border-right-0 pt-1 pb-1 sb-list-thitem-regular">
                                        {{ outputDate(i) }}
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 mt-4">
            <div class="card border-0" id="im-form">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title"><span v-if="update">Edit </span><span v-else>New </span>Immunization</p>
                    </div>
                </div>
                <div class="justify-content-center" v-if="update && im.id==''">
                    <div class="col-md-12 text-center pb-3">
                        <h5 class="mt-5 mb-5">SELECT IMMUNIZATION TO EDIT</h5>
                    </div>
                </div>
                <div v-else class="justify-content-center" id="al-form">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="mb-0">What is your new immunization?</label>
                            <small class="form-text text-muted mb-2">Entering the first few letters of your new immunization will display a suggestion.</small>
                            <multiselect
                                    v-model="im.imm_imd"
                                    track-by="imd_id"
                                    label="imd_name"
                                    placeholder="Select one"
                                    :searchable="true"
                                    :allow-empty="false"
                                    :options="immunizations"
                                    :taggable="true"
                                    @tag="addSrImm"
                                    tag-placeholder="Add new allergy"
                            >
                                <template slot="noOptions">Please type to search</template>
                            </multiselect>
                            <div class="form-group">
                                <input type="hidden" name="imm_imdid">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div>
                            <div class="form-group">
                                <label class="mb-0">Immunization date</label>
                                <date-picker valueType="format" v-model="im.created_at" lang="en" id="created_at" name="created_at" placeholder="Immunization date"></date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="text-right mb-3 mr-3">
                        <button v-if="!update" type="button" class="btn btn-success" @click.prevent="saveIm">Add to My Immunizations</button>
                        <button v-if="update" type="button" class="btn btn-success" @click.prevent="updateIm">Update My Immunization</button>
                        <br/>
                        <a href="/my-health" type="button" class="btn btn-outline-secondary mt-3">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
 </div>
</template>
<style>
    .mx-datepicker-popup{
        z-index: 10000;
    }
    .mx-datepicker{
        width: 100%;
    }
</style>

<script>
export default {
    props: ['immunizations', 'methodtype'],
    mounted() {
        this.listIm();
        this.addScreenReaderLabelsToMultiSelects();
        this.update = this.methodtype !== 'add';
    },
    data() {
        return {
            route: '/api/immunizations',
            update: false,
            im: {
                id: null,
                imm_imd: {imd_id: null},
                imm_imdid: null,
                imm_srname: null,
                created_at: ''
            },
            ims: []
        }
    },
    methods: {
        outputDate(i) {
            return moment(i.created_at).utc().format('MMMM DD, YYYY')
        },
        addSrImm(tag) {
            this.im.imm_srname = tag;
            this.im.imm_imd = {
                imd_name: tag,
                imd_id: 0
            };
        },
        saveIm() {
            //null safe injection
            if (this.im.imm_imd == null) {
                this.im.imm_imd = {imd_id: null};
            }

            this._clearErrors();

            this.$http.post(this.route, {
                imm_imdid: this.im.imm_imd.imd_id,
                imm_srname: this.im.imm_srname,
                created_at: this.im.created_at
            })
                .then(function (response) {
                    this.listIm();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Immunization was created!'
                    });
                    this.im = {
                        id: null,
                        imm_imd: null,
                        imm_imdid: null,
                        imm_srname: null,
                        created_at: ''
                    };
                }, (response) => {
                    this._handleErrors(response.data, '#im-form')
                })
        },
        listIm() {
            this.$http.get(this.route)
                .then(function (response) {
                    this.ims = response.data;
                    if(this.ims.length > 0 && this.update) this.show(this.ims[0])
                }, (response) => {
                    this._handleErrors(response.data, '#im-form')
                })
        },
        show(i) {
            this.update = true
            this.im = {
                id: i.imm_id,
                imm_imd: {
                    imd_id: i.imm_sr ? 0 : i.immunization_data.imd_id,
                    imd_name: i.imm_sr ? i.imm_srname : i.immunization_data.imd_name
                },
                imm_srname: i.imm_srname,
                imm_imdid: i.imm_imdid,
                created_at: i.created_at
            };
        },
        updateIm() {
            //null safe injection
            if (this.im.imm_imd == null) {
                this.im.imm_imd = {imd_id: null};
            }

            this._clearErrors();

            this.$http.put(this.route, {
                imm_id: this.im.id,
                imm_imdid: this.im.imm_imd.imd_id,
                imm_srname: this.im.imm_srname,
                created_at: this.im.created_at
            })
                .then(function (response) {
                    this.listIm();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Immunization was updated!'
                    });
                }, (response) => {
                    this._handleErrors(response.data, '#im-form')
                })
        },
        deleteImById(im) {
            if (!confirm('Do you really want to delete this immunization?'))
                return

            this.$http.delete(this.route + '/' + im.imm_id)
                .then(function (response) {
                    this.listIm();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Immunization was deleted!'
                    });
                    this.showModal = false;
                }, (response) => {
                    this._handleErrors(response.data, '#im-form')
                })
        },
        _handleErrors: function (items, selector) {
            this._clearErrors();

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        },
        _clearErrors: function () {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()
        },
        addScreenReaderLabelsToMultiSelects() {
            $('.multiselect__tags:first').attr('aria-label', 'Search For Immunization');
            $('input[name="date"]').attr('aria-label', 'Immunization Date');
        }
    }

}
</script>
